import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import { ORDER_BY } from './constants';

export const zodUsersAdminQueryParamsSchema = z
  .object({
    companyAccountId: z.uuid().optional(),
    companyId: z.uuid().optional(),
    limit: z.coerce
      .number()
      .gte(1)
      .max(100)
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT)
      .catch(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.coerce.number().nonnegative().prefault(0).catch(0),
    orderBy: z.enum(ORDER_BY).prefault('email'),
    returnTotalCount: z.boolean().prefault(false),
    searchString: z.string().optional(),
    sortOrder: z.enum(PAGINATION_SORT_DIRECTION).prefault('ASC'),
  })
  .transform((data) =>
    withoutObjectKeysWhereValueIs(data, [null, undefined, '']),
  );
